var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "77px",
    viewBox: "0 0 216 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OOO",
    transform: "translate(-17.000000, -58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,74 L46,74 C42.1340068,74 39,70.8659932 39,67 C39,63.1340068 42.1340068,60 46,60 L7,60 C3.13400675,60 0,56.8659932 0,53 C0,49.1340068 3.13400675,46 7,46 L47,46 C50.8659932,46 54,42.8659932 54,39 C54,35.1340068 50.8659932,32 47,32 L22,32 C18.1340068,32 15,28.8659932 15,25 C15,21.1340068 18.1340068,18 22,18 L62,18 C58.1340068,18 55,14.8659932 55,11 C55,7.13400675 58.1340068,4 62,4 L119,4 C122.865993,4 126,7.13400675 126,11 C126,14.8659932 122.865993,18 119,18 L183,18 C186.865993,18 190,21.1340068 190,25 C190,28.8659932 186.865993,32 183,32 L205,32 C208.865993,32 212,35.1340068 212,39 C212,42.8659932 208.865993,46 205,46 L186,46 C182.134007,46 179,49.1340068 179,53 C179,56.8659932 182.134007,60 186,60 L192,60 C195.865993,60 199,63.1340068 199,67 C199,70.8659932 195.865993,74 192,74 L140,74 C139.485125,74 138.983234,73.944412 138.5,73.8389102 C138.016766,73.944412 137.514875,74 137,74 Z M209,74 C205.134007,74 202,70.8659932 202,67 C202,63.1340068 205.134007,60 209,60 C212.865993,60 216,63.1340068 216,67 C216,70.8659932 212.865993,74 209,74 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,0 L77,73",
    id: "Line-4",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    x: 71.25,
    y: 4.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    x: 71.25,
    y: 31.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    x: 71.25,
    y: 58.25,
    width: 11.5,
    height: 11.5,
    rx: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.249125,4.25 L90.4930608,10 L94.249125,15.75 L161.75,15.75 L161.75,4.25 L94.249125,4.25 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.249125,31.25 L90.4930608,37 L94.249125,42.75 L161.75,42.75 L161.75,31.25 L94.249125,31.25 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.249125,57.25 L90.4930608,63 L94.249125,68.75 L161.75,68.75 L161.75,57.25 L94.249125,57.25 Z",
    id: "Rectangle",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateLogs);
export default __webpack_public_path__ + "static/media/empty-state-logs.a90cda568b6f958b0280bb6a91624079.svg";
export { ForwardRef as ReactComponent };